export default {
  getAll: {
    url: '/api/schedule/getAll',
    method: 'get'
  },
  create: {
    url: '/api/schedule/create',
    method: 'post'
  },
  update: {
    url: '/api/schedule/update',
    method: 'put'
  },
  delete: {
    url: '/api/schedule/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/schedule.js